import { tenantEnv } from "../packages/utils/utils";

const SandBoxTag = () => {
  const environmentName = tenantEnv.isStaging
    ? "DEVELOPMENT"
    : tenantEnv.getEnvironmentName()?.toUpperCase();

  const bannerBgClass = tenantEnv.isStaging ? "bg-info" : "bg-warning-110";

  return tenantEnv.isStagingOrSandbox ? (
    <div
      className={`${bannerBgClass} text-size-14 fixed left-0 top-0 right-0  px-5 py-1 text-center font-semibold text-white md:py-2`}
      style={{ zIndex: 60 }}
    >
      You are viewing the {environmentName} environment
    </div>
  ) : null;
};
export default SandBoxTag;
